'use strict';

class WorkersController {
    /* @ngInject */
    constructor(
        WorkersService,
        $scope
    ) {
        Object.assign(this, {
            WorkersService,
            $scope
        });

        this.query = {
            include: [
            ],
            where: {},
            limit: 10,
            page: 1,
            order: 'name DESC'
        };

        this.getModels();

        this.onPagination = () => {
            this.getModels();
        };

        this.onReorder = () => {
            this.getModels();
        };
    }

    getModels() {
        let qOpts = JSON.parse(JSON.stringify(this.query));

        let queryReady = this.WorkersService
            .getModels(qOpts)
            .then(workers => {
                this.workers = workers;
            });
        let countReady = this.WorkersService
            .getCount(qOpts)
            .then(result => {
                this.workersCount = result.count;
            });
        return Promise.all([queryReady, countReady]);
    }
}

export default WorkersController;
